import { noop } from '@blocksuite/global/utils';
import { GET_DEFAULT_TEXT_COLOR } from '../../components/panel/color-panel.js';
import { addText } from '../../utils/text.js';
import { EdgelessToolController } from './index.js';
export class TextToolController extends EdgelessToolController {
    constructor() {
        super(...arguments);
        this.tool = {
            type: 'text',
            color: GET_DEFAULT_TEXT_COLOR(),
        };
    }
    onContainerClick(e) {
        addText(this._edgeless, e, this.tool.color);
    }
    onContainerContextMenu() {
        noop();
    }
    onContainerPointerDown() {
        noop();
    }
    onContainerDblClick() {
        noop();
    }
    onContainerTripleClick() {
        noop();
    }
    onContainerDragStart() {
        noop();
    }
    onContainerDragMove() {
        noop();
    }
    onContainerDragEnd() {
        noop();
    }
    onContainerMouseMove() {
        noop();
    }
    onContainerMouseOut() {
        noop();
    }
    onPressShiftKey(_) {
        noop();
    }
    beforeModeSwitch() {
        noop();
    }
    afterModeSwitch(newTool) {
        this._tryLoadTextStateLocalRecord(newTool);
    }
    _tryLoadTextStateLocalRecord(tool) {
        if (tool.type !== 'text')
            return;
        const key = 'blocksuite:' + this._edgeless.page.id + ':edgelessText';
        const textData = sessionStorage.getItem(key);
        if (textData) {
            try {
                const { color } = JSON.parse(textData);
                this._edgeless.slots.edgelessToolUpdated.emit({
                    type: 'text',
                    color: color ?? GET_DEFAULT_TEXT_COLOR(),
                });
            }
            catch (_) {
                noop();
            }
        }
    }
}
//# sourceMappingURL=text-tool.js.map